import React from 'react';

import { Button, Icon } from '@rbilabs/universal-components';

import { DebugToolModal } from 'components/debug-tool';
import { Typography } from 'components/ui';
import { LoyaltyOffer, LoyaltyReward } from 'state/loyalty/types';

import { IncentiveDebug } from './incentive-debug';

interface IIncentiveDebugProps {
  incentive: LoyaltyOffer | LoyaltyReward;
}
interface IIncentiveDebugModalProps extends IIncentiveDebugProps {
  onClose: () => void;
}

const IncentiveDebugModal = ({ onClose, incentive }: IIncentiveDebugModalProps) => {
  return (
    <DebugToolModal onOpenEventMessage="Loyalty Debug Tool: Incentive detail" onClose={onClose}>
      <IncentiveDebug incentive={incentive} />
    </DebugToolModal>
  );
};

export const IncentiveDebugTool = (props: IIncentiveDebugProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <>
      <Button
        style={{ position: 'absolute', top: 0, left: 0, zIndex: 99999 }}
        variant="ghost"
        onPress={() => setIsModalOpen(true)}
        leftIcon={<Icon name="mi:bug-report" />}
        marginY="$4"
      >
        <Typography>View Incentive{'\n'} info</Typography>
      </Button>

      {isModalOpen && <IncentiveDebugModal {...props} onClose={() => setIsModalOpen(false)} />}
    </>
  );
};
